import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'
import type {Deprecation} from '../apiUtils/deprecation'
import type {PublicMethodUtils} from '@wix/document-services-types'
import type {DeprecationPublicAPI} from '@wix/document-services-public-types'

export default function (
    publicMethodUtils: PublicMethodUtils,
    deprecation: Deprecation
): PublicModuleDeclaration<DeprecationPublicAPI> {
    return {
        methods: {
            deprecation: {
                setThrowOnDeprecation: publicMethodUtils.defineAction(deprecation.setThrowOnDeprecation)
            }
        }
    }
}
